exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".XR_U3{background:#f3d8d8}._35aVJ{background:#bce0bc}._38364{background:#fff}.Y5_jg{padding:0!important}._2rcis{padding:7px 3px}._3rtqj div{overflow-x:hidden!important}._3rtqj div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"pendiente": "XR_U3",
	"procesada": "_35aVJ",
	"normal": "_38364",
	"tdClear": "Y5_jg",
	"field": "_2rcis",
	"hidden": "_3rtqj"
};